import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import toast from '@helpers/toast';

import { fetchInventoryApi, saveStoneApi } from './inventory.api';
import {
  fetchInventoryFailure,
  fetchInventoryRequest,
  fetchInventorySuccess,
  saveStoneFailure,
  saveStoneRequest,
  saveStoneSuccess,
} from './inventory.slice';

import { StoneInventory } from '@stone/interfaces';
import { handleSagaError } from '@stone/sagaHelpers';

function* fetchInventorySaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    const response: { items: StoneInventory[]; totalCount: number } = yield call(fetchInventoryApi, action.payload);
    yield put(fetchInventorySuccess(response));
  } catch (error: any) {
    yield handleSagaError(error, fetchInventoryFailure, 'Failed to load inventory');
  }
}

function* saveStoneSaga(action: PayloadAction<any>): Generator<any, void, any> {
  try {
    yield call(saveStoneApi, action.payload);
    yield put(saveStoneSuccess());
    toast.success('Stone saved successfully');
    yield put(fetchInventoryRequest({ searchCriteria: { pageSize: 20, currentPage: 1 } }));
  } catch (error: any) {
    yield handleSagaError(error, saveStoneFailure, 'Failed to save stone');
  }
}

export default function* inventorySaga() {
  yield takeLatest(fetchInventoryRequest.type, fetchInventorySaga);
  yield takeLatest(saveStoneRequest.type, saveStoneSaga);
}
